@for (control of formArray.controls; track control) {
  <div class="ui vertically padded grid">
    <div class="fifteen wide column">
      <ng-container [ngTemplateOutlet]="formTemplate" [ngTemplateOutletContext]="{
        $implicit: control,
        $index, $count, $first, $last, $even, $odd,
      }"></ng-container>
    </div>
    <div class="one wide column">
      <button class="ui red icon button" type="button" (click)="delete($index)">
        <i class="minus icon"></i>
      </button>
    </div>
  </div>
}
<button
  [disabled]="formArray.length > 0 && !formArray.controls[formArray.length - 1].value"
  class="ui small secondary button"
  type="button"
  (click)="add()"
>
  <i class="plus icon"></i>
  {{ addButtonLabel }}
</button>
@if (!formArray.controls.length && emptyError) {
  <div class="ui left pointing red basic label">
    {{ emptyError }}
  </div>
}
